export default __webpack_public_path__ + "images/dc0a436ff5963f80a910c59ee58b005e-Industry-Light.woff";